/** if customReportTitle contains any ${MY_VAR}, replace the contents with a variables from `variables` object */
export function handleCustomTitle(
  customReportTitle: string,
  variables: { [key: string]: string | number | undefined }
) {
  return customReportTitle.replace(/\${(.*?)}/g, (_, g1) => {
    return variables[g1] || variables[g1] === 0 ? String(variables[g1]) : "";
  });
}
